import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from "@material-ui/core";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { generatePath, useHistory } from "react-router-dom";

/** Import router */
import { appPath, paramName } from "../../router/AppRoute";
import { useAppSelector } from "../../app/hooks";
import { CxQuestionPage } from "../../entity/entities";
import { useTranslation } from 'react-i18next';

/** Import reducers */
import { answeredToPage, pageAnswered } from "./PreviewReducer";

export const Buttons = (props: {
  pageIndex: number;
  cxQuestionPages: CxQuestionPage[];
}) => {
  const { pageIndex, cxQuestionPages } = props;
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const isPageAnswered = useAppSelector((state) =>
    pageAnswered({
      state: state.preview,
      pageIndex,
    })
  );

  const errorCount = useAppSelector((state) => state.preview.errorCount);

  const handleNextClick = () => {
    if (!isPageAnswered) {
      setErrorMessage(t('common.error.there_is_an_unanswered_question'));
      setOpen(true);
      return;
    }

    if (errorCount > 0) {
      setErrorMessage(t("common.error.an_item_was_not_filled_in_correctly"));
      setOpen(true);
      return;
    }
    dispatch(
      answeredToPage({
        pageIndex,
      })
    );

    const toUrlInputNext = generatePath(appPath.shopqr.inputAnswerPreview, {
      [paramName.surveyQestionPageIndexStr]: pageIndex + 1,
    });

    history.replace({ pathname: toUrlInputNext });
    return false;
  };

  const handlePrevClick = () => {
    if (errorCount > 0) {
      setErrorMessage(t("common.error.an_item_was_not_filled_in_correctly"));
      setOpen(true);
      return;
    }

    let toUrlInputPrev: string = generatePath(appPath.shopqr.inputBranch);
    if (pageIndex > 0) {
      toUrlInputPrev = generatePath(appPath.shopqr.inputAnswerPreview, {
        [paramName.surveyQestionPageIndexStr]: pageIndex - 1,
      });
    }

    history.replace(toUrlInputPrev);
    return false;
  }

  const handleClose = () => setOpen(false);

  const notificationTextSubmit = (
    <Box mt={3} fontSize="20px" fontWeight="fontWeightBold">
      {t('common.preview_mode_cannot_submit_response')}
    </Box>
  );

  let Buttons = (
    <Button
      variant="outlined"
      color="secondary"
      fullWidth
      onClick={handleNextClick}
    >
      {t('preview.btn.next')}
    </Button>
  );

  if (pageIndex === cxQuestionPages.length - 1) {
    if (pageIndex === 0) {
      Buttons = (
        <Box>
          <Button variant="contained" color="primary" fullWidth disabled>
            {t('preview.btn.send_response')}
          </Button>
          {notificationTextSubmit}
        </Box>
      );
    } else {
      Buttons = (
        <Grid container>
          <Grid item xs={6}>
            <Box mr={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handlePrevClick}
              >
                {t('preview.btn.back')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={1}>
              <Button variant="contained" color="primary" fullWidth disabled>
                {t('preview.btn.send_response')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {notificationTextSubmit}
          </Grid>
        </Grid>
      );
    }
  } else if (pageIndex > 0) {
    Buttons = (
      <>
        <Grid container>
          <Grid item xs={6}>
            <Box mr={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handlePrevClick}
              >
                {t('preview.btn.back')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handleNextClick}
              >
                {t('preview.btn.next')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      {Buttons}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            autoFocus
          >
            {t('preview.btn.ok')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
